import React from "react";
import { HostedFieldsTokenizePayload, ApplePayPayload } from "braintree-web";
import { ConfirmationToken } from "@stripe/stripe-js";
import { AuthorizationResponse } from "paypal-checkout-components";
import {
  HandleSelectNewPayment,
  HandleSelectSavedPayment,
  HandleSelectSavedCreditCard,
  PaymentContextInterface,
  HandleSelectSavedAllocatedCredit,
} from "./hooks/usePaymentProvider";
import {
  AllowedPaymentMethod,
  AvailablePaymentMethodsFragment,
} from "v3/services/graphql/generated";

export const PaymentContext = React.createContext<PaymentContextInterface>({
  availablePaymentMethods: null,
  clearPaymentDataOnEdit: () => {},
  handleSelectApplePay: (_props: HandleSelectNewPayment) => {},
  handleSelectInvoice: () => {},
  handleSelectNewCreditCard: (_props: HandleSelectNewPayment) => {},
  handleSelectNewP24: (_props: HandleSelectNewPayment) => {},
  handleSelectNewBlik: (_props: HandleSelectNewPayment) => {},
  handleSelectNewPayPal: (_props: HandleSelectNewPayment) => {},
  handleSelectSavedCreditCard: (_props: HandleSelectSavedCreditCard) => {},
  handleSelectSavedPayPal: (_props: HandleSelectSavedPayment) => {},
  handleSelectSavedAllocatedCredit: (
    _props: HandleSelectSavedAllocatedCredit
  ) => {},
  newApplePayResponse: null,
  newCreditCardBraintreeResponse: null,
  newPayPalResponse: null,
  paymentNonce: null,
  paymentType: null,
  saveCardForLater: false,
  savePaymentInput: null,
  setAvailablePaymentMethods: (_methods: AvailablePaymentMethodsFragment) => {},
  setNewApplePayResponse: (_data: ApplePayPayload) => {},
  setNewCreditCardBraintreeResponse: (
    _payload: HostedFieldsTokenizePayload
  ) => {},
  setNewPayPalResponse: (_data: AuthorizationResponse) => {},
  setPaymentNonce: (_data: string | null) => {},
  setPaymentType: (_data: AllowedPaymentMethod) => {},
  setSaveCardForLater: (_saveCardForLater: boolean) => {},
  setStripeTokenDetails: (_tokenDetails: ConfirmationToken) => {},
  stripeTokenDetails: null,
  generatePaymentIntentSecret: (_checkoutSessionId: string) =>
    Promise.resolve(),
  setIsBillingEqualShipping: (_data: boolean) => {},
  isBillingEqualShipping: null,
  setPaymentIntentSecret: (_val: string | null) => {},
  paymentIntentSecret: null,
});
